import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { InteractiveMapComponent } from './interactive-map/interactive-map.component';
import { GoogleMapsModule } from '@angular/google-maps';

@NgModule({
  imports: [CommonModule, GoogleMapsModule, IonicModule],
  declarations: [InteractiveMapComponent],
  exports: [InteractiveMapComponent],
})
export class InteractiveMapModule {}
